export function getHourlyStats(timeList: string []) {
    let timeCounts: number[] = new Array(24).fill(0);
    let sumCounts: number[] = new Array(24).fill(0);

    // Count occurrences per hour
    timeList.forEach((time) => {
        let hour = new Date(time).getHours();
        timeCounts[hour]++;
    });

    // Compute cumulative sum
    sumCounts[0] = timeCounts[0];
    for (let i = 1; i < 24; i++) {
        sumCounts[i] = sumCounts[i - 1] + timeCounts[i];
    }

    return {
        time: timeCounts,
        sum: sumCounts
    };
}
